/**
 * Ansprechpartner eines Showcases stehen im Admin als ein Text: Namen,
 * getrennt an Komma, Semikolon, Schrägstrich oder „und“, wahlweise mit
 * Mailadresse in spitzen Klammern — `Jana Buchter <jana.buchter@j4p.de>`.
 * Die Mail braucht K4ia, um die Person in Teams anzuschreiben; der Name
 * reicht für Smenso und für die Antwort „Wer ist Ansprechpartner?“.
 * Einträge, die mit „Team“ beginnen, sind keine Personen.
 */
export interface Contact {
  name: string
  email?: string
}

export function parseContacts(text: string): Contact[] {
  return text
    .split(/[,;/\n]|\s+und\s+|\s+&\s+/i)
    .map((t) => t.trim().replace(/\s+/g, ' '))
    .filter((t) => t.length > 1)
    .map((t) => {
      const m = /^(.*?)\s*[<(]\s*([^\s<>()]+@[^\s<>()]+)\s*[>)]\s*$/.exec(t)
      if (m) return { name: m[1]!.trim() || m[2]!, email: m[2]!.toLowerCase() }
      const nurMail = /^[^\s<>()]+@[^\s<>()]+$/.test(t)
      return nurMail ? { name: t.split('@')[0]!, email: t.toLowerCase() } : { name: t }
    })
    .filter((c) => !/^team\b/i.test(c.name))
}

export function formatContacts(contacts: Contact[]): string {
  return contacts
    .filter((c) => c.name.trim() || c.email)
    .map((c) => (c.email ? `${c.name.trim() || c.email} <${c.email.trim()}>` : c.name.trim()))
    .join(', ')
}

/** Nur die Namen — für Smenso-Zuweisung und den Prompt. */
export function contactNames(text: string): string[] {
  return parseContacts(text).map((c) => c.name)
}
